import { jsx as _jsx } from "react/jsx-runtime";
import React, { Children } from 'react';
import styled, { css } from 'styled-components';
import { map } from '../breakpoint';
import { mapFlexWidths } from '../utils';
import { Hidden } from '../Hidden';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ColumnWrapper = styled(({ width, hiddenAbove, hiddenBelow, flex, ...rest })=>hiddenAbove || hiddenBelow ? /*#__PURE__*/ _jsx(Hidden, {
        above: hiddenAbove,
        below: hiddenBelow,
        ...rest
    }) : /*#__PURE__*/ _jsx("div", {
        ...rest
    }))`
  min-width: 0;

  ${({ flex })=>flex && `
    display: flex;
    width: 100%;
  `};

  ${({ width })=>width ? map(width, (val)=>val === 'content' || val === '1' ? `
              flex: 0 0 auto;
              width: ${val === 'content' ? 'auto' : '100%'};
            ` : css`
                flex: 0 0 ${mapFlexWidths(val)}%;
                width: 100%;
              `) : css`
          width: 100%;
        `}
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ColumnChild = styled(({ flex, ...rest })=>/*#__PURE__*/ _jsx("div", {
        ...rest
    }))`
  ${({ flex })=>flex && `
    display: flex;
    width: 100%;
  `};
`;
export const Column = ({ children, width, hiddenAbove, hiddenBelow, flex = false, ...otherProps })=>/*#__PURE__*/ _jsx(ColumnWrapper, {
        "data-mesh-component": "COLUMN",
        width: width,
        hiddenAbove: hiddenAbove,
        hiddenBelow: hiddenBelow,
        flex: flex,
        ...otherProps,
        children: Children.map(children, (child)=>{
            if (/*#__PURE__*/ React.isValidElement(child)) {
                return /*#__PURE__*/ _jsx(ColumnChild, {
                    flex: flex,
                    children: child
                });
            }
            return null;
        })
    });
Column.displayName = 'Column';

//# sourceMappingURL=index.js.map